// ----------------------------------------------------------------------
// <copyright file="Izenda.LicenseInfo.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * License Info component
 */
!(function () {
  require('share/utils/Izenda.StringUtilities');

  var observer = require('mobx-react').observer;
  var classnames = require('classnames');
  var connect = require('share/enhancers/Izenda.Connect');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var React = require('react');
  var Panel = require('share/components/controls/Izenda.Panel');
  var ProductInfo = require('api/Izenda.Version');

  var LicenseInfoHeader = function header(props) {
    var localization = props.localization;
    return (<GridLayout>
      <GridLayout.Row>
        <GridLayout.Col cols={2}>
          <strong>{localization.getText("LICENSE_CHECKER_LABEL_LICENSE_INFORMATION")}</strong>
        </GridLayout.Col>
        <GridLayout.Col cols={10}>
          <span>{props.productVersion}</span>
        </GridLayout.Col>
      </GridLayout.Row>
    </GridLayout>);
  };

  var LicenseInfo = React.createClass({

    propTypes: {
      item: React.PropTypes.object.isRequired,
      store: React.PropTypes.object
    },


    render: function () {
      var licenseInfo = this.props.item;
      var localization = this.props.localization;

      if (!licenseInfo.isValidLicense) {
        return null;
      }

      if ( licenseInfo.numberOfDayToValid > 0 ) {
        return null;
      }
      var header = {
        component: LicenseInfoHeader,
        productVersion: ProductInfo.VERSION,
        localization: localization
      };
      return (
        <Panel header={header}
               className={classnames('panel-default','izenda-LicenseInfo',
                                     {'disabled-elm' : !this.props.validatedConnection})}>
          {getLicense.bind(this)()}
        </Panel>
      );


      function getLicense() {
        var localization = this.props.localization;
        if (licenseInfo.licenseOnlineMode || !licenseInfo.previousStartDate) {
          return (
            <div className='padding-t current-module'>
              {this.renderLicenseInfo(localization.getText("LICENSE_CHECKER_LABEL_CURRENT_DURATION"),
                [licenseInfo.startDate, licenseInfo.licenseEndDate],
                localization.getText("LICENSE_CHECKER_LABEL_CURRENT_MODULE"), licenseInfo.modules, 'current-module')}
            </div>
          );
        } else {
          return (
            <div className='row flex-layout'>
              <div className='col-md-6 padding-t previous-module'>
                {this.renderLicenseInfo(localization.getText("LICENSE_CHECKER_LABEL_PREVIOUS_DURATION"),
                  [licenseInfo.previousStartDate, licenseInfo.previousEndDate],
                  localization.getText("LICENSE_CHECKER_LABEL_PREVIOUS_MODULE"), licenseInfo.previousModules)}
              </div>
              <div className='col-md-6 padding-t current-module'>
                {this.renderLicenseInfo(localization.getText("LICENSE_CHECKER_LABEL_NEXT_DURATION"),
                  [licenseInfo.startDate, licenseInfo.endDate],
                  localization.getText("LICENSE_CHECKER_LABEL_NEXT_MODULE"), licenseInfo.modules)}
              </div>
            </div>
            );
        }
      }
    },


    renderLicenseInfo: function (durationLabel, duration, moduleLabel, modules ) {
      modules = modules || [];

      if (!duration[0] && !duration[1]) {
        return null;
      }

      return (
        <section>
            <div className='row'>
                <label className="col-md-2">{durationLabel}</label>
                <span className="col-md-10">
                  {String.formatDate(duration[0])} - {String.formatDate(duration[1])}
                </span>
            </div>
            <div className='row'>
                <label className="col-md-2">{moduleLabel}</label>
                <div className="col-md-10 modules">
                  {modules.map(function (module, index) {
                    return (
                      <div key={index} className='module' >
                        <i className="icon-ok success-color" />{module.name}
                      </div>
                      );
                  })}
                </div>
            </div>
        </section>
        );
    }
  });



  module.exports = connect()(LicenseInfo);
}());



// WEBPACK FOOTER //
// ./ui/modules/Settings/LicenseChecker/Izenda.LicenseInfo.jsx